import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";

class FreeTools extends Component {
  state = {
    tools: [
      {
    title: "Payweek Accounting Desktop",
    description:
      "Download the Payweek Accounting Desktop application with transaction management, reconciliation, profit & loss reporting, cash-in tracking, and more.",
    link: "/downloads/Payweek-Accounting-Setup.exe",
    buttonText: "Download for Windows",
  },
      {
        title: "Breakeven Calculator",
        description:
          "Find the weekly sales amount your business needs to cover labor, fixed costs, and variable costs.",
        link: "/breakeven",
        buttonText: "Use Calculator",
      },
      {
  title: "Labor Schedule Planner",
  description:
    "Build employee schedules visually, calculate labor hours and payroll costs, and manage staffing based on operating hours.",
  link: "/labor-schedule-planner",
  buttonText: "Build Schedule",
},
      
    ],
  };

  render() {
    return (
      <section className="pwlp-free-tools-section" id="free-tools">
        <Container>
          <div className="pwlp-free-tools-heading">
            <span className="pwlp-free-tools-kicker">Free Tools</span>
            <h2>Business tools you can use for free</h2>
            <p>
              Simple tools to help business owners understand payroll, costs,
              profitability, and sales targets.
            </p>
          </div>

          <Row className="pwlp-free-tools-grid">
            {this.state.tools.map((tool, index) => (
              <Col lg="4" md="4" className="pwlp-free-tools-col" key={index}>
              
                <div className="pwlp-free-tools-card">
                  <div className="pwlp-free-tools-icon">
                    {index + 1}
                  </div>

                  <h4>{tool.title}</h4>
                  <p>{tool.description}</p>

                  <a href={tool.link} className="pwlp-free-tools-btn">
                    {tool.buttonText}
                  </a>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    );
  }
}

export default FreeTools;